import { Component, OnInit } from '@angular/core';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToastrService } from 'ngx-toastr';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-alert-configuration',
  templateUrl: './alert-configuration.component.html',
  styleUrls: ['./alert-configuration.component.scss'],
})
export class AlertConfigurationComponent implements OnInit {
  search = '';
  count = 10;
  offset = 0;
  desc = false;
  alerts: any[] = [];
  hugeAdmin = false;
  AccessObject: UserAccessRole;
  constructor(
    private titleService: TitleService,
    private matDialogService: MatDialog,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private auth: UserRightsService,
    private toastService: ToastrService,
  ) {}

  alertSettings: any[];
  alertTypes: any[];
  alertData: any[] = [];
  alertTypesIsEmpty: boolean;
  isAlertTypesLoaded: boolean;
  isAlertSettingsLoaded: boolean;

  ngOnInit() {
    this.hugeAdmin = this.auth.IsHugeAdmin();
    // this.closePopover();
    this.AccessObject = this.auth.GetUserAccessRoles();
    if (this.AccessObject == null) {
      return;
    }
    this.getAlertData();
  }

  createSetting(setting: any) {
    const settingObj = {
      TypeID: setting.TypeID,
      RecipientEmails: setting.RecipientEmails,
      Enabled: setting.Enabled,
    };

    this.genericService.POST(this.endpoints.CREATE_ALERT_SETTING, settingObj).subscribe(() => {
      this.getAlertData();
    });
  }

  updateSetting(setting: any) {
    this.genericService.PUT(this.endpoints.UPDATE_ALERT_SETTING(setting.Id), setting).subscribe(() => {
      this.getAlertData();
    });
  }

  addSetting(setting: any) {
    if (setting.Id != null && setting.Id > 0) {
      this.genericService.GET(this.endpoints.GET_ALERT_SETTINGS(10, 0, '', 'TypeID', false)).subscribe((result: any) => {
        const alertSettings = result['body'];
        if (alertSettings != null) {
          const alertSetting = alertSettings.filter((x) => x.TypeID == setting.TypeID);
          if (alertSetting == null) {
            // create new setting
            this.createSetting(setting);
          } else {
            // Update setting
            this.updateSetting(setting);
          }
        }
        this.isAlertSettingsLoaded = true;
      });
    } else {
      this.createSetting(setting);
    }
  }

  getAlertData() {
    this.genericService.GET(this.endpoints.GET_ALERT_TYPES(10, 0, '', 'Name', false)).subscribe((result) => {
      if (result['body'] != null) {
        const types = [];
        result['body'].forEach((element) => {
          if ((element.ID == 1 || element.ID == 2 || element.ID == 4) && (this.AccessObject.IsCDRAdmin() || this.AccessObject.IsSuperUser()) && this.auth.HasCDRAccess()) {
            types.push(element);
          } else if (element.ID == 3 && (this.AccessObject.IsKeepAliveAdmin() || this.AccessObject.IsSuperUser()) && this.auth.HasKeepAliveAccess()) {
            types.push(element);
          }
        });
        this.alertTypes = types;
        this.isAlertTypesLoaded = true;
      } else {
        this.alertTypesIsEmpty = true;
      }
    });

    this.genericService.GET(this.endpoints.GET_ALERT_SETTINGS(10, 0, '', 'TypeID', false)).subscribe((result) => {
      if (result['body'] != null) {
        const settings = [];
        result['body'].forEach((element) => {
          if ((element.TypeID == 1 || element.TypeID == 2 || element.TypeID == 4) && (this.AccessObject.IsCDRAdmin() || this.AccessObject.IsSuperUser()) && this.auth.HasCDRAccess()) {
            settings.push(element);
          } else if (element.TypeID == 3 && (this.AccessObject.IsKeepAliveAdmin() || this.AccessObject.IsSuperUser()) && this.auth.HasKeepAliveAccess()) {
            settings.push(element);
          }
        });
        this.alertSettings = settings;
      }
      this.isAlertSettingsLoaded = true;
    });
  }
}
